"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestUser = void 0;
const fetchable_1 = require("./fetchable");
const object_1 = require("./objects/object");
const rest_1 = require("./rest");
const rest_department_1 = require("./rest.department");
class IkeRestUser {
    constructor(core, accessToken) {
        this.Objects = object_1.IkeRestObjects;
        this.User = {
            Settings: {
                change: this.bindAction('user.settings.set'),
            },
            me: this.bindAction('user.me'),
            ipfDatabases: this.bindAction('user.ipf.databases'),
        };
        this.Version = {
            check: this.bindAction('version.check'),
        };
        this.Department = {
            list: this.bindAction('department.list'),
            adminList: this.bindAction('department.admin.list'),
            writeableList: this.bindAction('department.writeable.list'),
        };
        this.Org = {
            getById: this.bindAction('org.get.orgid'),
        };
        this.Device = {
            getByDeviceId: this.bindAction('device.get.deviceid'),
        };
        this.Event = {
            batch: this.bindAction('event.batch'),
            extract: this.bindAction('event.extract'),
            process: this.bindAction('event.process'),
        };
        this.core = core;
        this.log = core.log.child({ accessToken });
        this.accessToken = accessToken;
        this.me = new fetchable_1.IkeFetchableOne(this.log, rest_1.IkeRest.createStore(), () => this.User.me());
        this.departments = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), () => this.Department.list().then((c) => c.results));
        this.adminDepartments = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), () => this.Department.adminList().then((c) => c.results));
        this.writeableDepartments = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), () => this.Department.writeableList().then((c) => c.results));
    }
    bind(departmentId) {
        if (this.boundDepartmentId !== departmentId) {
            this.boundDepartmentId = departmentId;
            this.boundDepartmentRest = new rest_department_1.IkeRestDepartment(this, departmentId);
        }
        return this.boundDepartmentRest;
    }
    action(action, data) {
        return this.core._post(action, data, this.accessToken, null);
    }
    bindAction(action) {
        return (data) => this.action(action, data);
    }
}
exports.IkeRestUser = IkeRestUser;
//# sourceMappingURL=rest.user.js.map